/**
 * Political/Advocacy Roles
 *
 * Centralized list of common roles that are likely to use political graphics
 * and creative tooling. Sorted by relevance to hands-on campaign creative work.
 */

export const politicalRoles = [
  { key: 'candidate', label: 'Candidate' },
  { key: 'campaign_staff', label: 'Campaign Staff / Operative' },
  { key: 'consultant', label: 'Consultant' },
  { key: 'digital_firm', label: 'Digital Firm' },
  { key: 'advocacy_nonprofit', label: 'Advocacy Group / Nonprofit' },
  { key: 'other', label: 'Other' }
];

export function getRoleLabelByKey(key) {
  const found = politicalRoles.find(r => r.key === key);
  return found ? found.label : null;
}

export function getRolesForSelect() {
  return politicalRoles.map(r => ({ value: r.key, label: r.label }));
}

export default politicalRoles;


